export enum VideoProviderUrlEnum {
    DAILYMOTION = 'https://www.dailymotion.com/embed/video/',
    FACEBOOK = 'https://www.facebook.com/watch/?v=',
    VIMEO = 'https://player.vimeo.com/video/',
    YOUTUBE = 'https://www.youtube.com/embed/',
}
